"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class CompanyModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            category: 'Industry',
            description: 'Description',
            name: 'Name',
            numberOfEmployees: 'NumberOfEmployees',
            ownerId: 'OwnerId',
            recordTypeId: 'RecordTypeId',
            type: 'Type'
        };
    }
    transformToSalesforce() {
        const sfCompany = super.transformToSalesforce();
        sfCompany.Website = this.website.url;
        sfCompany.Phone = this.phone.number;
        sfCompany.Fax = this.fax.number;
        sfCompany.ShippingStreet = this.shippingAddress.street;
        sfCompany.ShippingCity = this.shippingAddress.city;
        sfCompany.ShippingState = this.shippingAddress.state;
        sfCompany.ShippingPostalCode = this.shippingAddress.postalCode;
        sfCompany.ShippingCountry = this.shippingAddress.country;
        sfCompany.BillingStreet = this.billingAddress.street;
        sfCompany.BillingCity = this.billingAddress.city;
        sfCompany.BillingState = this.billingAddress.state;
        sfCompany.BillingPostalCode = this.billingAddress.postalCode;
        sfCompany.BillingCountry = this.billingAddress.country;
        return sfCompany;
    }
    transformFromSalesforce(sfCompany) {
        super.transformFromSalesforce(sfCompany);
        this.phone = new _1.PhoneNumberModel('Phone', sfCompany.Phone);
        this.fax = new _1.PhoneNumberModel('Fax', sfCompany.Fax);
        this.website = new _1.WebsiteModel('Website', sfCompany.Website);
        this.billingAddress = new _1.AddressModel('Billing Address', sfCompany.BillingAddress);
        this.shippingAddress = new _1.AddressModel('Shipping Address', sfCompany.ShippingAddress);
    }
    transformFromJson(json) {
        Object.assign(this, json);
        this.phone = new _1.PhoneNumberModel('Phone', json.phone);
        this.fax = new _1.PhoneNumberModel('Fax', json.fax);
        this.website = new _1.WebsiteModel('Website', json.website);
        this.billingAddress = new _1.AddressModel('Billing Address', json.billingAddress || {
            billingStreet: json.billingStreet,
            billingCity: json.billingCity,
            billingState: json.billingState,
            billingPostalCode: json.billingPostalCode,
            billingCountry: json.billingCountry
        });
        this.shippingAddress = new _1.AddressModel('Shipping Address', json.shippingAddress || {
            shippingStreet: json.shippingStreet,
            shippingCity: json.shippingCity,
            shippingState: json.shippingState,
            shippingPostalCode: json.shippingPostalCode,
            shippingCountry: json.shippingCountry
        });
    }
}
CompanyModel.Types = [
    'Brokerage',
    'Owner/Investor',
    'Tenant',
    'Vendor',
    'Other'
];
CompanyModel.Industries = [
    'Agriculture',
    'Apparel',
    'Banking',
    'Biotechnology',
    'Chemicals',
    'Communications',
    'Construction',
    'Consulting',
    'Education',
    'Electronics',
    'Energy',
    'Engineering',
    'Entertainment',
    'Environmental',
    'Finance',
    'Food & Beverage',
    'Government',
    'Healthcare',
    'Hospitality',
    'Insurance',
    'Machinery',
    'Manufacturing',
    'Media',
    'Not For Profit',
    'Other',
    'Recreation',
    'Retail',
    'Shipping',
    'Technology',
    'Telecommunications',
    'Transportation',
    'Utilities',
    'Real Estate',
    'Materials',
    'Software'
];
exports.CompanyModel = CompanyModel;
//# sourceMappingURL=company.model.js.map